<script setup>
import { Input, TextArea } from "./ui/Index";
import { onClickOutside }  from "@vueuse/core";
import { ref, computed }   from "vue";
import { useMainStore } from "@/store/main";
import { Arrow, Close } from "./Icons";
import { useApi } from "@/composables/useApi";

const { sendCallback } = useApi();
const mainStore        = useMainStore();

const isOpen = defineModel();

const errors    = ref({});
const isAgree   = ref(false);
const targetEl  = ref(null);
const isPressed = ref(false);

const userData  = ref({
	firstname    : '',
	phone   : '',
	comment : '',
})

const hasError = computed(() => Object.values(errors.value).some(el => el));

const checkForm = async () => {
	if (isPressed.value) {
		if (userData.value.firstname.length < 3)
			errors.value.firstname = 'Минимальная длина имени - 3 символа';
		else
			errors.value.firstname = '';
		if (userData.value.phone.trim().length != 18)
			errors.value.phone = 'Неверная длина номера телефона';
		else
			errors.value.phone = '';
	}
};

const handleSubmit = async () => {
	isPressed.value = true;
	await checkForm();

	if (!hasError.value) {
		try {
			await sendCallback(userData.value.phone, userData.value.firstname, userData.value.comment);
			mainStore.completeOrder = true;
		} catch {}
	}
};

onClickOutside(targetEl, () => isOpen.value = false)
</script>
<template>
	<div class="fast-order">
		<div class="fast-order-wr" ref="targetEl">
			<div class="fast-order__header">
				<button class="fast-order__back" @click="isOpen = false">
					<Arrow />
					Назад
				</button>
				<button
					class="form__close-btn"
					@click="mainStore.isClosePopup = true"
				>
					<Close />
				</button>
			</div>
			<div class="form__label fast-order__label">
				<h2>Быстрая запись</h2>
				<p>Заполните короткую форму, и мы свяжемся с вами в ближайшее время</p>
			</div>
			<div class="form user-form">
				<div>
					<Input
						class="user__name"
						name="user__name"
						placeholder="Имя"
						v-model:value="userData.firstname"
						@input="checkForm"
					/>
					<span class="error-label" v-if="errors.firstname">{{ errors.firstname }}</span>
				</div>
				<div>
					<Input
						class="user__phone"
						name="user__phone"
						placeholder="+7"
						v-model:value="userData.phone"
						:mask-options="{ mask: '+7 (###) ###-##-##' }"
						@input="checkForm"
					/>
					<span class="error-label" v-if="errors.phone">{{ errors.phone }}</span>
				</div>
				<TextArea v-model="userData.comment" />
			</div>
			<div class="privacy-policy">
				<input
					id="fast-privacy-policy"
					type="checkbox"
					name="privacy-policy"
					v-model="isAgree"
				>
				<label class="custom-checkbox" for="fast-privacy-policy" />
				<label class="privacy__content" for="fast-privacy-policy">Я согласен(на) на обработку персональных данных и принимаю пользовательское соглашение</label>
			</div>
			<div class="user-form__order-wr">
				<button
					class="long-btn user-form__order"
					:disabled="!isAgree || hasError"
					@click="handleSubmit"
				>
					Записаться
				</button>
			</div>
		</div>
	</div>
</template>
<style lang='scss'>
.fast-order {
	position: fixed;
	z-index: 10;
	inset: 0;
	display: flex;
	background-color: #0000008A;

	@include mq($desktop) { padding-inline: 30px }
}

.fast-order-wr {
	width: 100%;
	max-width: 996px;
	margin: auto;
	display: flex;
	overflow-y: auto;
	flex-direction: column;
	height: 100%;
	padding: 20px 16px;
	background-color: #FFF;
	position: relative;

	.form__label {
		width: fit-content;
		margin-top: 70px;
		margin-inline: auto;
	}

	@include mq($tablet) {
		.user-form {
			grid-template-rows: repeat(3, 60px);

			.textarea-wr { grid-row: 2 / 4 }
		}
	}

	@include mq($desktop) {
		max-height: 538px;
		border-radius: 20px;
		padding: 40px;

		.form__label { margin-top: 0px }

		.form__label p { max-width: 600px }

		.user-form {
			grid-template-columns: repeat(2, 1fr);
			grid-template-rows: repeat(2, 60px);

			.textarea-wr {
				grid-row: 1 / 3;
				grid-column: 2 / 3;
			}
		}
	}
}

.fast-order__header {
	display: flex;
	justify-content: space-between;

	button { height: 44px }

	@include mq($desktop) {
		justify-content: flex-end;
		gap: 12px;
		position: absolute;
		z-index: 3;
		right: 40px;
	}
}

.fast-order__back {
	display: flex;
	align-items: center;
	gap: 10px;
	border-radius: 12px;
	width: fit-content;
	padding-inline: 16px 22px;
	background-color: $yellow;
	font-size: 14px;
	font-weight: 600;
	color: #FFF;

	svg {
		height: 18px;
		transform: rotate(90deg);
	}
}

.user-form__order-wr {
	padding-bottom: 100px;

	@include mq(560px) { padding-bottom: 0 }
}
</style>